// Active feature flags
export const ADMINS_ONLY = 'admin';
export const MONTHLY_DONATE = 'monthly-enabled';

export const getIsFeatureOn = (feature: string) => {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  return searchParams.has(feature);
};
